export const getPracticePlanStatus = (practice) => practice?.practicePlanStatus || 'NONE';

export const isClubAdminForClub = (club, user) =>
  Boolean(club?.adminUserId && user?.id && String(club.adminUserId) === String(user.id));

export const canEditPracticePlanForClub = (club, user, myMember, isAdminFn) => {
  if (!user?.id) return false;
  if (typeof isAdminFn === 'function' && isAdminFn()) return true;
  if (isClubAdminForClub(club, user)) return true;
  return myMember?.roles?.includes('PRACTICE_SPECIALIST') ?? false;
};

export const hasVisiblePlanContent = (practicePlan) => {
  if (!practicePlan) return false;
  return (
    (practicePlan.objectives && practicePlan.objectives.length > 0) ||
    practicePlan.warmup?.description ||
    (practicePlan.drills && practicePlan.drills.length > 0) ||
    practicePlan.playerNotes
  );
};

export const getPlanBadge = (practice, { canEdit = false } = {}) => {
  const status = getPracticePlanStatus(practice);
  if (status === 'PUBLISHED') {
    return { label: 'Plan ready', className: 'practice-plan-badge practice-plan-badge--ready' };
  }
  if (status === 'DRAFT' && canEdit) {
    return { label: 'Draft', className: 'practice-plan-badge practice-plan-badge--draft' };
  }
  return { label: 'Plan pending', className: 'practice-plan-badge practice-plan-badge--pending' };
};

export const planTemplateToForm = (template) => {
  if (!template) {
    return null;
  }
  return {
    objectives: template.objectives?.length ? [...template.objectives] : [''],
    warmup: {
      durationMinutes: template.warmup?.durationMinutes ?? '',
      description: template.warmup?.description || '',
    },
    drills: template.drills?.length
      ? template.drills.map((d) => ({
          name: d.name || '',
          durationMinutes: d.durationMinutes ?? '',
          description: d.description || '',
          focusArea: d.focusArea || '',
        }))
      : [{ name: '', durationMinutes: '', description: '', focusArea: '' }],
    playerNotes: template.playerNotes || '',
  };
};
